<template>
  <div>
    <p>{{ $t('component.blur.notRegistered') }}</p>

    <!-- Until we have a centralized place they can buy any GCG product.. -->
    <!--<p>
      <span
        style="cursor: pointer; text-decoration: underline; color: #409eff;"
        @click="openLink"
      >{{ $t('component.blur.subscribeToday') }}</span>.
    </p>-->

    <p>
      <i18n path="component.blur.supportDesc">
        <template #email>
          <a
            style="color: #409eff;"
            href="mailto:Support@GlobalCoachGroup.com"
          >Support@GlobalCoachGroup.com</a>
        </template>
      </i18n>
    </p>
  </div>
</template>

<script>
export default {
  name: 'BlurService',

  // methods: {
  //   openLink() {
  //     window.open('https://gla-360.com/plans/', '_self');
  //   },
  // },
};
</script>
